import styled from "styled-components";
import {
  mediaQuery,
  pageContentMaxWidth,
  pageContentPadding
} from "../theme/constants";
import { ReactNode } from "react";
import { ContentContainer } from "./Layout/ContentContainer";

const Section = styled.section<{ background?: string }>`
  background: ${(props) => props.background ?? "none"};
  width: 100%;
  padding: 80px 0;
  position: relative;
  ${mediaQuery.small} {
    padding: 56px 0;
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > * {
    position: absolute;
  }
  overflow: hidden;
`;

export const PageSection = ({
  children,
  background,
  className,
  backgroundImage,
  id
}: {
  id?: string;
  children?: ReactNode;
  background?: string;
  className?: string;
  backgroundImage?: ReactNode;
}) => {
  return (
    <Section background={background} className={className} id={id}>
      {backgroundImage && <BackgroundImage>{backgroundImage}</BackgroundImage>}
      <ContentContainer>{children}</ContentContainer>
    </Section>
  );
};
